function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { forwardRef, useState } from 'react';
import styled, { css } from 'styled-components';
import colors from "../../../colors";
import { getTypographyFontStyle } from "../../../theme/selectors";
import Text from "../../Typography/Text";
import { keyCode } from "../../../enums/keyCodeEnums";
var defaultThemeTextArea = {
  borderRadius: 6,
  padding: '12px',
  bgColor: colors.paleGreyThree,
  color: colors.black,
  hover: {
    bgColor: colors.silverFour
  },
  focus: {
    bgColor: colors.white,
    boxShadow: "0 4px 12px 0 rgba(0, 0, 0, 0.05), 0 2px 6px 0 rgba(0, 0, 0, 0.05), 0 0 4px 0 rgba(0, 0, 0, 0.05)"
  },
  placeholder: {
    color: colors.warmGrey
  }
};
var Container = styled.div.withConfig({
  displayName: "Textarea__Container",
  componentId: "sc-1fj1gnp-0"
})(["position:relative;"]);
var Asterisk = styled.span.attrs({
  children: ' *'
}).withConfig({
  displayName: "Textarea__Asterisk",
  componentId: "sc-1fj1gnp-1"
})(["color:", ";"], colors.reddishPink);
export var ErrorMessage = styled(Text).attrs({
  color: colors.reddishPink,
  size: 100
}).withConfig({
  displayName: "Textarea__ErrorMessage",
  componentId: "sc-1fj1gnp-2"
})(["margin-top:4px;width:100%;"]);
var Placeholder = styled(Text).attrs({
  size: 200
}).withConfig({
  displayName: "Textarea__Placeholder",
  componentId: "sc-1fj1gnp-3"
})(["", " position:absolute;top:11px;left:12px;z-index:1;display:block;pointer-events:none;", ";"], function (_ref) {
  var _textAreaTheme$placeh;

  var textAreaTheme = _ref.textAreaTheme;
  return css(["color:", ";font-weight:", ";"], textAreaTheme === null || textAreaTheme === void 0 ? void 0 : (_textAreaTheme$placeh = textAreaTheme.placeholder) === null || _textAreaTheme$placeh === void 0 ? void 0 : _textAreaTheme$placeh.color, textAreaTheme === null || textAreaTheme === void 0 ? void 0 : textAreaTheme.fontWeight);
}, function (_ref2) {
  var isKomus = _ref2.isKomus;

  if (isKomus) {
    return css(["line-height:16px !important;font-size:14px !important;font-weight:normal;color:", " !important;"], colors.dark100);
  }
});
var Content = styled.span.withConfig({
  displayName: "Textarea__Content",
  componentId: "sc-1fj1gnp-4"
})(["display:block;width:100%;user-select:text;box-sizing:border-box;outline:none;position:relative;transition:background-color 300ms ease-out;white-space:pre-line;letter-spacing:-0.3px;cursor:pointer;", " ", ";&:focus + ", "{@media not all and (min-resolution:0.001dpcm){display:none;}}", " word-break:break-word;text-align:left;&:not(:empty) + ", "{display:none;}"], function (_ref3) {
  var textAreaTheme = _ref3.textAreaTheme;
  return css(["font-weight:", ";padding:", ";border-radius:", "px;background-color:", ";color:", ";&:hover{background-color:", ";}&:focus{background-color:", ";box-shadow:", ";}"], textAreaTheme === null || textAreaTheme === void 0 ? void 0 : textAreaTheme.fontWeight, textAreaTheme.padding, textAreaTheme.borderRadius, textAreaTheme.bgColor, textAreaTheme.color, textAreaTheme.hover.bgColor, textAreaTheme.focus.bgColor, textAreaTheme.focus.boxShadow);
}, function (_ref4) {
  var isKomus = _ref4.isKomus;

  if (isKomus) {
    return css(["line-height:16px !important;font-size:14px !important;"]);
  }
}, Placeholder, getTypographyFontStyle(200), Placeholder);
var Textarea = forwardRef(function (props, ref) {
  var placeholder = props.placeholder,
      text = props.text,
      onChange = props.onChange,
      _props$onKeyDown = props.onKeyDown,
      onKeyDown = _props$onKeyDown === void 0 ? function () {
    return null;
  } : _props$onKeyDown,
      maxLength = props.maxLength,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      required = props.required,
      errorMsg = props.errorMsg,
      _props$textAreaTheme = props.textAreaTheme,
      textAreaTheme = _props$textAreaTheme === void 0 ? defaultThemeTextArea : _props$textAreaTheme,
      testId = props.testId,
      isKomus = props.isKomus;

  var theme = _objectSpread({}, defaultThemeTextArea, {}, textAreaTheme);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      lengthErr = _useState2[0],
      setLengthErr = _useState2[1];

  var handleChange = function handleChange(e) {
    var textContent = e.currentTarget.textContent;
    if (onChange) onChange(textContent || '');
  };

  var handleKeyDown = function handleKeyDown(e) {
    var textContent = e.currentTarget.textContent;
    if (onKeyDown) onKeyDown(e);

    if (textContent && maxLength && e.key !== keyCode.Backspace && textContent.length >= maxLength) {
      e.preventDefault();
      setLengthErr(true);
    } else {
      setLengthErr(false);
    }
  };

  var handlePaste = function handlePaste(e) {
    e.preventDefault();
    var pastedText = e.clipboardData.getData('text/plain');

    if (maxLength && pastedText.length > maxLength) {
      pastedText = pastedText.substring(0, maxLength);
      setLengthErr(true);
    } else {
      setLengthErr(false);
    }

    document.execCommand('insertHTML', false, pastedText);
  };

  return React.createElement(Container, null, React.createElement(Content, {
    "data-testid": testId,
    ref: ref,
    contentEditable: true,
    suppressContentEditableWarning: true,
    "aria-multiline": "true",
    onInput: handleChange,
    onKeyDown: handleKeyDown,
    onPaste: handlePaste,
    onBlur: onBlur,
    onFocus: onFocus,
    textAreaTheme: theme,
    isKomus: isKomus
  }, text), placeholder && React.createElement(Placeholder, {
    textAreaTheme: theme,
    isKomus: isKomus
  }, placeholder, " ", required && React.createElement(Asterisk, null)), !errorMsg && lengthErr && React.createElement(ErrorMessage, null, "\u041C\u0430\u043A\u0441. \u0434\u043B\u0438\u043D\u0430 ", maxLength));
});
Textarea.displayName = 'Textarea';
export default Textarea;